// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebGetUserFavoritesRequest,
  TWebGetUserFavoritesModel,
  IMappers,
  TWebGetUserFavoritesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFavoritesForDesktopResponseSchema } from '../../../entities/get_favorites_for_desktop/GetFavoritesForDesktopResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebGetUserFavoritesModel(parameters: TWebGetUserFavoritesRequest): TWebGetUserFavoritesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/get-user-favorites/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebGetUserFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebGetUserFavoritesRequest;
}

export async function fetchWebGetUserFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebGetUserFavoritesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebGetUserFavoritesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebGetUserFavoritesModel(parameters),
    config,
  )) as FetchResponse<TWebGetUserFavoritesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFavoritesForDesktopResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebGetUserFavoritesResponse>;
}
